import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('variations', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        show: (cntx, { id }) => new Promise((resolve, reject) => {
            axios.get(`variations/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('variations', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        // PUT /variations/{id}  →  { approved: 1 | -1, remarks: string }
        update: (cntx, { id, data }) => new Promise((resolve, reject) => {
            axios.put(`variations/${id}`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`variations/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
